import Navbar from "../components/Navbar";
import ServiceHero from "../components/ServiceHero";
import WhyChooseUs from "../components/WhyChooseUs";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

const MobileAppDevelopment = () => {
  return (
    <>
      <Navbar />

      <ServiceHero
        title="Mobile App Development"
        subtitle="Beautiful Android and iOS applications built for performance, scalability and exceptional user experiences."
      />

      <WhyChooseUs />

      <CTA />

      <Footer />

      <WhatsAppButton />
    </>
  );
};

export default MobileAppDevelopment;